import React from 'react'

const SvgFolderFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 22c-2 0-2-2-2-2V4c0-2 2-2 2-2h5l3 2h8c2 0 2 2 2 2v14s0 2-2 2H4z'
    />
  </svg>
)

export default SvgFolderFilled
